import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_TWITTER_BIDDING_RULES = gql`
  query GetList($request: TwitterBiddingRulesRequest!) {
    GetTwitterBiddingRules(request: $request) {
      ... on TwitterBiddingRulesResponse {
        data_type
        data {
          ... on TwitterBiddingRules {
            currency
            minimum_cpe_bid_local_micro
            maximum_cpe_bid_local_micro
            minimum_denomination
          }
        }
      }
    }
  }
`;
